import { DefaultSelection36CorrespondenceIssuedPayload } from "@api";
import LocalContractUserService from "@services/local-contractUser.service";
import { NA } from "@shared/staticValue";
import { getDateFormatted_MMDDYYYY } from "@shared/utils";

export default class ResponseDetailItem {
  public Title: string;

  public RequestResponse: boolean;

  public DueDate: string;

  public Note: string;

  public Collapse: boolean;

  constructor(item: DefaultSelection36CorrespondenceIssuedPayload, localContractUserService: LocalContractUserService) {
    const role = localContractUserService.getUserRole(item.UpdatedBy);
    const name = localContractUserService.getUserInfo(item.UpdatedBy)?.displayName;
    this.Title = role && name ? `${name}  |  ${role}` : NA;
    this.RequestResponse = item.RequireResponse;
    this.DueDate = item.DueDate ? getDateFormatted_MMDDYYYY(item.DueDate) : NA;
    this.Note = item.Note ?? NA;
    this.Collapse = false;
  }
}
